/**
 * Datadog Environment Configuration
 * Manages environment variables for Datadog integration
 */

// Load package.json version once at module load to avoid repeated file reads
const packageVersion = (() => {
  try {
    return require('../../../../package.json').version;
  } catch {
    return '0.0.0';
  }
})();

export const DATADOG_ENABLED = process.env.REACT_APP_DATADOG_ENABLED === 'true';
export const DATADOG_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '';
export const DATADOG_SERVICE = process.env.REACT_APP_DATADOG_SERVICE || 'lessee-portal';
export const DATADOG_HOST = process.env.REACT_APP_DATADOG_HOST || 'localhost';
export const DATADOG_SOURCE = process.env.REACT_APP_DATADOG_SOURCE || 'browser';
export const DATADOG_SITE = process.env.REACT_APP_DATADOG_SITE || 'datadoghq.com';
export const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
export const APP_VERSION = process.env.REACT_APP_VERSION || packageVersion;
export const EXPLICIT_LOGGING_ONLY = process.env.REACT_APP_EXPLICIT_LOGGING_ONLY === 'true';
